export default __webpack_public_path__ + "static/media/vector4.88780929.svg";